export enum FilterLinkOperatorEnum {
  And = 0,
  Or = 1
}
